import React from 'react';

const cloneFilterActions = (actions, props) =>
  React.Children.toArray(actions)?.reduce((acc, action) => {
    const ActionElement = React.isValidElement(action)
      ? React.cloneElement(action, { ...props, fontSize: 18 })
      : null;

    return ActionElement ? [...acc, ActionElement] : acc;
  }, []);

export default cloneFilterActions;
